import { render } from "./UserCreateForm.vue?vue&type=template&id=35adbbf6"
import script from "./UserCreateForm.vue?vue&type=script&lang=js"
export * from "./UserCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__